import { createSlice } from '@reduxjs/toolkit';
import api from '../config/configApi';

// Estado inicial do carrinho
const initialState = {
  items: [],
  loading: false,
  error: false,
};

// Slice do carrinho
const cartReducer = createSlice({
  name: 'cart',
  initialState,
  reducers: {
    // Substitui o carrinho inteiro
    addCarrinho: (state, action) => {
      state.items = action.payload;
      state.loading = false;
      state.error = false;
    },

    // Adiciona um novo item ao carrinho
    addPost: (state, action) => {
      state.items.push(action.payload);
    },

    // Sinaliza erro
    addError: (state) => {
      state.error = true;
      state.loading = false;
    },

    // Remove item por id
    deleteFromCart: (state, action) => {
      const index = state.items.findIndex(el => el.id_produto === action.payload);
      if (index !== -1) state.items.splice(index, 1);
    },

    // Atualiza quantidade via select
    updateItemFromSelect: (state, action) => {
      const item = state.items.find(el => el.id_produto === action.payload.id_produto);
      if (item) item.quantity = Number(action.payload.value);
    },

    // Adiciona item ou incrementa quantidade
    adicionarItem: (state, action) => {
      const existente = state.items.find(i => i.nome === action.payload.nome);
      if (existente) {
        existente.quantidade = (existente.quantidade || 1) + 1;
      } else {
        state.items.push({ ...action.payload, quantidade: 1 });
      }
    },

    // Atualiza a quantidade de um item com base no índice
    atualizarQuantidadeItem: (state, action) => {
      const item = state.items[action.payload.index];
      if (!item) return;
      item.quantidade += action.payload.delta;
      if (item.quantidade <= 0) {
        state.items.splice(action.payload.index, 1);
      }
    },

    // Limpa o carrinho
    limparCarrinho: (state) => {
      state.items = [];
    },
  }
});

// Exportação das ações
export const {
  addCarrinho,
  addPost,
  addError,
  deleteFromCart,
  updateItemFromSelect,
  adicionarItem,
  atualizarQuantidadeItem,
  limparCarrinho,
} = cartReducer.actions;

// Exporta reducer principal
export default cartReducer.reducer;

// Thunk para buscar carrinho da API
export function getCarrinho() {
  return async function (dispatch) {
    try {
      const response = await api.get('/carrinho.php', { withCredentials: true });
      dispatch(addCarrinho(response.data));
    } catch (error) {
      console.error("Erro ao buscar carrinho:", error);
      dispatch(addError());
    }
  };
}
